import {createRouter, createWebHistory} from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Layout from "@/layout/Layout"
import store from '../store'
import { verify } from '../api/serviceApi'
const routes = [
    {
        path: '/main',
        component: Layout,
        icon: "el-icon-s-home",
        meta: {title: "工作台", requireAuth: true},
        redirect: '/home',
        children: [
            {
                path: "/home",
                name: "工作台",
                icon: "el-icon-s-home",
                meta: {title: "工作台", requireAuth: true},
                component: () => import('@/views/Home.vue')
            }
        ]
    },
    {
        path: "/config",
        name: "配置管理",
        component: Layout,
        icon: "el-icon-menu",
        meta: {title: "配置管理", requireAuth: true},
        children: [
            {
                path: "/pay/master",
                name: "收款主体&产品",
                icon: "el-icon-document",
                meta: {title: "收款主体&产品", requireAuth: true},
                component: () => import("@/views/Collection.vue")
            },
            {
                path: "/pay/relation",
                name: "主体关联",
                icon: "el-icon-document",
                meta: {title: "主体关联", requireAuth: true},
                component: () => import("@/views/Relation.vue")
            },
            {
                path: "/pay/paylog",
                name: "交易流水",
                icon: "el-icon-document",
                meta: {title: "交易流水", requireAuth: true},
                component: () => import("@/views/PayLog.vue")
            },
        ]
    },
    {
        path: '/401',
        name: '401',
        meta: {title: "401", requireAuth: false},
        component: () => import('@/views/401.vue')
    },
    {
        path: '/index',
        name: 'index',
        meta: {title: "index", requireAuth: true},
        component: () => import('@/views/Main.vue')
    },
]

// createRouter 创建路由实例
const router = createRouter({
    /**
     * hash模式：createWebHashHistory，
     * history模式：createWebHistory
     */
    history: createWebHistory(),
    routes
})

NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 600, showSpinner: false })

router.beforeEach((to, from, next) => {
    // console.log(process.env.VUE_APP_KONG_API_URL)
    // console.log(process.env.VUE_APP_API_URL)
    // //测试
    // adminBaseInfo().then(res=>{
    //     console.log(res)
    //     console.log(res.message)
    // })
    // console.log(localStorage.getItem('token'))
    if(to.path=='/index'){
        if(to.query.jwt){
            store.commit('setToken',to.query.jwt)
            next({path:'/home'})
        }else{
            next({path:'/401'})
        }
    }else if(to.path=='/401'){
        next()
    }else{
        let token=localStorage.getItem('token')
        if(token){
            verify().then(res=>{
                if(res.code==200){
                    next()
                }else{
                    next({path:'/401'})
                }
            })
        }else{
            next({path:'/401'})
        }
    }
    
    
    // 启动进度条
    NProgress.start()

    // 设置头部
    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = "默存"
    }
})

router.afterEach(() => {
    // 关闭进度条
    NProgress.done()
})


// 抛出路由实例, 在 main.js 中引用
export default router